import axios from "axios";
import Data from "../Data/Data.json";
import { getCsrfToken } from "../utilitaires/csrf";


// Instance axios unique à utiliser PARTOUT dans l'application
// (login, groupMenu_api, groupUser_api, menu_api, mfaApi, etc.)
// au lieu d'appeler axios.get/post/put/delete directement.
const api = axios.create({
  baseURL: Data.ApiUrl.BaseUrl,
  withCredentials: true, // essentiel : envoie le cookie AuthToken (HttpOnly) sur chaque requête
});

// Injecte automatiquement le header X-CSRF-TOKEN sur les requêtes qui modifient des données.
api.interceptors.request.use((config) => {
  const method = config.method?.toUpperCase();
  if (method && ["POST", "PUT", "DELETE", "PATCH"].includes(method)) {
    const token = getCsrfToken();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers["X-CSRF-TOKEN"] = token;
    } else {
      // Utile en debug : si ce log apparaît avant login, c'est normal
      // (endpoint anonyme). S'il apparaît après login, le cookie XSRF-TOKEN
      // n'a pas été posé -> vérifier l'appel à /Authentification/csrf-token.
      console.warn("[CSRF] Aucun token CSRF trouvé pour", config.url);
    }
  }
  return config;
});

// Gestion centralisée d'une session expirée / CSRF invalide (optionnel mais pratique)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("[AUTH] 401 reçu sur", error.config?.url, "- session ou CSRF invalide");
      // Ici vous pouvez déclencher une redirection vers /login, ou un refresh du csrf-token
    }
    return Promise.reject(error);
  }
);

export default api;
